import React from "react";

export const ThunderstormsIcon = () => (
    <svg
        tabIndex={-1}
        focusable="false"
        className="svg-icon icon-weather"
        width="80px"
        height="80px"
        fill="none"
        viewBox="0 0 80 80"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g className="weather-fill" id="04" fill="#3F4447">
                <g transform="translate(2.000000, 10.000000)">
                    <path
                        d="M5 40.715c0 8.112 6.67 14.678 14.887 14.678h43.578C69.83 55.393 75 50.304 75 44.015c0-6.29-5.17-11.378-11.535-11.378-1.015 0-2.014.13-2.978.383a1.479 1.479 0 10.752 2.86 8.738 8.738 0 012.226-.286c4.742 0 8.577 3.776 8.577 8.421s-3.835 8.42-8.577 8.42H19.887c-6.593 0-11.93-5.252-11.93-11.72 0-6.222 4.954-11.358 11.258-11.702.725-.04 1.314-.6 1.39-1.322.755-7.192 6.944-12.72 14.367-12.72 5.292 0 10.077 2.82 12.613 7.273a1.479 1.479 0 002.57-1.464c-3.059-5.372-8.822-8.767-15.183-8.767-8.515 0-15.695 6.058-17.138 14.163C10.561 27.164 5 33.319 5 40.716z"
                        fill="#717277"
                    />
                    <path
                        d="M43.483 63.365a1.479 1.479 0 10-2.092-2.092l-4.88 4.88a1.479 1.479 0 102.092 2.092l4.88-4.88zM33.625 63.365a1.479 1.479 0 00-2.091-2.092l-4.88 4.88a1.479 1.479 0 002.091 2.092l4.88-4.88zM63.201 63.365a1.479 1.479 0 00-2.091-2.092l-4.88 4.88a1.479 1.479 0 002.091 2.092l4.88-4.88zM53.344 63.365a1.479 1.479 0 00-2.091-2.092l-4.88 4.88a1.479 1.479 0 002.091 2.092l4.88-4.88zM23.764 63.365a1.479 1.479 0 00-2.091-2.092l-4.88 4.88a1.479 1.479 0 002.09 2.092l4.881-4.88z"
                        fill="#9ADAFF"
                    />
                    <path
                        d="M63.657 25.51c1.29-.004 1.967 1.531 1.092 2.48L48.123 46.044c-1.16 1.26-3.178-.133-2.41-1.665l5.694-11.355h-7.464c-1.292 0-1.963-1.54-1.082-2.487l16.797-18.052c1.157-1.243 3.155.126 2.413 1.654l-5.537 11.394 7.123-.022zm-3.378 2.968l-6.107.02a1.479 1.479 0 01-1.335-2.126l2.254-4.638-7.752 8.331h6.463c1.1 0 1.816 1.158 1.322 2.142l-2.056 4.1 7.211-7.829z"
                        fill="#FCBA38"
                    />
                </g>
            </g>
        </g>
    </svg>
);
